import { useQuery, gql, type TypedDocumentNode } from '@apollo/client';
import { type TActivityName } from '../../../shared/activity-name-enum';

type DiscoverRentalSportsInput = {
  input: {
    cityName: string;
  };
};

type DiscoverRentalSportsResponse = {
  discoverRentalSports: {
    sportNames: TActivityName[];
  };
};

const GET_DISCOVER_RENTAL_SPORTS: TypedDocumentNode<
  DiscoverRentalSportsResponse,
  DiscoverRentalSportsInput
> = gql`
  query DiscoverRentalSports($input: DiscoverRentalsInput!) {
    discoverRentalSports(input: $input) {
      sportNames
    }
  }
`;

const useDiscoverRentalSports = (cityName: string, isRental: boolean) => {
  const { data, loading, error } = useQuery(GET_DISCOVER_RENTAL_SPORTS, {
    skip: !cityName || !isRental,
    variables: {
      input: { cityName },
    },
  });

  const { discoverRentalSports } = data || {};
  const sportNames = discoverRentalSports?.sportNames || [];

  return { sportNames, loading, error };
};

export default useDiscoverRentalSports;
